import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { ReferenceDataStoreModel } from "../../../../models/store/reference-data.store.model";
import { DefaultStoreData } from "@bitwarden/web-vault/app/models/store/store.data";
import { reference_v1_to_v2 } from "../model-dto/reference-data";

export class ReferenceDataParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported ReferenceData parser version ${version}`);
    }

    if (version === 0) {
      return (obj: any) => ({ ...DefaultStoreData });
    } else if (version === 1) {
      return ReferenceDataParser_v1;
    } else if (version === 2) {
      return ReferenceDataParser_v2;
    }
  }

  override getSupportedVersion(): number[] {
    return [0, 1, 2];
  }
}

const ReferenceDataParser_v2 = (referenceDataObj: any): any =>
  referenceDataObj as ReferenceDataStoreModel;

const ReferenceDataParser_v1 = (referenceDataObj: any) => {
  const referenceData = reference_v1_to_v2(referenceDataObj);
  return ReferenceDataParser_v2(referenceData);
};
